import { useState } from 'react';
import { X, Check } from 'lucide-react';
import { documenti as documentiApi } from '../../utils/api';
import { useToast } from '../../hooks/useToast';
import Toast from '../shared/Toast';
import { copiaTesto } from '../../utils/clipboard';

const CARD_SHADOW = '0 6px 18px rgba(35,38,47,0.08)';

const fmtData = (d) => d ? new Date(d).toLocaleDateString('it-IT', { day: '2-digit', month: 'long', year: 'numeric' }) : '';

export default function CondividiModal({ documento, onClose, onLinkCreato }) {
  var [giorni, setGiorni] = useState(7);
  var [pinRichiesto, setPinRichiesto] = useState(false);
  var [notificaApertura, setNotificaApertura] = useState(true);
  var [result, setResult] = useState(null);
  var [loading, setLoading] = useState(false);
  var { toasts, showToast, dismissToast } = useToast();

  var genera = async function() {
    setLoading(true);
    try {
      var res = await documentiApi.condividi(documento.id, {
        scadenza_giorni: giorni,
        pin_richiesto: pinRichiesto,
        notifica_apertura: notificaApertura,
      });
      setResult(res.data);
      if (onLinkCreato) onLinkCreato();
    } catch (err) {
      var msg = err.response?.data?.detail || 'Errore nella generazione del link';
      showToast(msg, 'error');
    } finally {
      setLoading(false);
    }
  };

  // FE-057 — copia con fallback (helper condiviso): funziona anche dove
  // navigator.clipboard e' assente (http, vari webview mobile). Il toast
  // segue l'ESITO reale della copia, non l'ottimismo di prima.
  var copiaLink = async function() {
    if (!result?.url_condivisione) return;
    var ok = await copiaTesto(result.url_condivisione);
    showToast(ok ? 'Link copiato!' : 'Copia non riuscita', ok ? 'success' : 'error');
  };

  var copiaPin = async function() {
    if (!result?.pin) return;
    var ok = await copiaTesto(result.pin);
    showToast(ok ? 'PIN copiato!' : 'Copia non riuscita', ok ? 'success' : 'error');
  };

  var inp = { width: '100%', padding: '9px 12px', borderRadius: 'var(--radius-base)', border: '0.5px solid var(--ds-border)', fontSize: 13, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', background: 'var(--ds-bg)', color: 'var(--ds-text)' };
  var lbl = { display: 'block', fontSize: 11, fontWeight: 500, color: 'var(--ds-muted)', marginBottom: 4 };
  var toggleRow = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0' };
  var toggleLabel = { fontSize: 13, fontWeight: 400, color: 'var(--ds-text)' };

  function Toggle(props) {
    var on = props.value;
    return (
      <button
        type="button"
        onClick={function() { props.onChange(!on); }}
        style={{
          width: 44, height: 24, borderRadius: 12, border: 'none', cursor: 'pointer',
          background: on ? 'var(--brand)' : 'var(--ds-border)',
          position: 'relative', transition: 'background 150ms',
          minWidth: 44, minHeight: 44, display: 'flex', alignItems: 'center',
          padding: 0,
        }}
      >
        <span style={{
          width: 18, height: 18, borderRadius: '50%', background: '#fff',
          position: 'absolute', top: 3,
          left: on ? 23 : 3,
          transition: 'left 150ms',
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        }} />
      </button>
    );
  }

  return (
    <>
      <Toast toasts={toasts} dismissToast={dismissToast} />
      <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ background: 'var(--ds-bg)', borderRadius: 'var(--radius-card)', width: '100%', maxWidth: 460, boxShadow: CARD_SHADOW }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: '0.5px solid var(--ds-border)' }}>
            <span style={{ fontSize: 15, fontWeight: 500, color: 'var(--ink)', fontFamily: 'var(--font-display)' }}>Condividi &mdash; {documento.nome_file}</span>
            <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ds-muted)', minWidth: 44, minHeight: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><X size={20} strokeWidth={2} /></button>
          </div>
          <div style={{ padding: '20px 24px' }}>
            {!result ? (
              <>
                <div style={{ marginBottom: 16 }}>
                  <label style={lbl}>Scadenza link</label>
                  <select style={inp} value={giorni} onChange={function(e) { setGiorni(Number(e.target.value)); }}>
                    <option value={1}>1 giorno</option>
                    <option value={3}>3 giorni</option>
                    <option value={7}>7 giorni</option>
                    <option value={14}>14 giorni</option>
                    <option value={30}>30 giorni</option>
                  </select>
                </div>

                <div style={toggleRow}>
                  <span style={toggleLabel}>PIN richiesto</span>
                  <Toggle value={pinRichiesto} onChange={setPinRichiesto} />
                </div>

                <div style={toggleRow}>
                  <span style={toggleLabel}>Notifica apertura</span>
                  <Toggle value={notificaApertura} onChange={setNotificaApertura} />
                </div>

                <p style={{ fontSize: 11, color: 'var(--ds-muted)', margin: '8px 0 20px' }}>
                  Il link scade automaticamente. Chi lo riceve non ha bisogno di un account mAIstro.
                </p>
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                  <button onClick={onClose} style={{ padding: '9px 18px', borderRadius: 'var(--radius-base)', border: '0.5px solid var(--ds-border)', background: 'var(--ds-bg)', cursor: 'pointer', fontSize: 13, fontWeight: 500, color: 'var(--ds-text)', minHeight: 44 }}>Annulla</button>
                  <button onClick={genera} disabled={loading} style={{ padding: '9px 20px', borderRadius: 'var(--radius-base)', border: 'none', background: 'var(--brand)', color: '#fff', cursor: loading ? 'not-allowed' : 'pointer', fontSize: 13, fontWeight: 500, opacity: loading ? 0.7 : 1, minHeight: 44 }}>
                    {loading ? 'Generazione...' : 'Crea link condivisione'}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                  <span style={{ color: 'var(--brand)', display: 'flex', alignItems: 'center' }}><Check size={18} strokeWidth={2} /></span>
                  <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--ink)', fontFamily: 'var(--font-display)' }}>Link creato con successo</span>
                </div>

                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>URL</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input readOnly style={{ ...inp, flex: 1, background: 'var(--chip)', fontSize: 11 }} value={result.url_condivisione} />
                    <button onClick={copiaLink} style={{ padding: '9px 14px', borderRadius: 'var(--radius-base)', border: 'none', background: 'var(--brand)', color: '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap', minHeight: 44 }}>Copia link</button>
                  </div>
                </div>

                {result.pin && (
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>PIN</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        {result.pin.split('').map(function(c, i) {
                          return (
                            <span key={i} style={{
                              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                              width: 36, height: 44, borderRadius: 'var(--radius-base)',
                              border: '0.5px solid var(--ds-border)',
                              background: 'var(--chip)',
                              fontSize: 20, fontWeight: 500, fontFamily: 'monospace',
                              color: 'var(--ink)',
                            }}>{c}</span>
                          );
                        })}
                      </div>
                      <button onClick={copiaPin} style={{ padding: '9px 14px', borderRadius: 'var(--radius-base)', border: '0.5px solid var(--ds-border)', background: 'var(--ds-bg)', cursor: 'pointer', fontSize: 12, fontWeight: 500, color: 'var(--ds-text)', minHeight: 44 }}>Copia PIN</button>
                    </div>
                    <p style={{ fontSize: 11, color: 'var(--ds-muted)', margin: '8px 0 0' }}>Comunica questo PIN al destinatario separatamente. Il PIN e il link sono stati inviati anche via email.</p>
                  </div>
                )}

                <div style={{ fontSize: 12, color: 'var(--ds-muted)', marginBottom: 14 }}>
                  Scade il {fmtData(result.scadenza)}
                </div>

                <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end' }}>
                  <button onClick={onClose} style={{ padding: '9px 18px', borderRadius: 'var(--radius-base)', border: '0.5px solid var(--ds-border)', background: 'var(--ds-bg)', cursor: 'pointer', fontSize: 13, fontWeight: 500, color: 'var(--ds-text)', minHeight: 44 }}>Chiudi</button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
